import { Button } from '@/components/ui';
import type { ScheduleOccurrenceSourceType } from '@/utils/scheduleOccurrences';

const SOURCE_LABELS: Record<ScheduleOccurrenceSourceType, string> = {
  lesson: 'Lessons',
  court_hire: 'Court hire',
  closure: 'Closures',
  play_event: 'Play events',
};

export interface ScheduleSourceTypeFilterBarProps {
  availableSourceTypes: ScheduleOccurrenceSourceType[];
  activeSourceFilters: ScheduleOccurrenceSourceType[];
  onToggle: (source: ScheduleOccurrenceSourceType) => void;
  className?: string;
  /** When set, renders as a labeled field inside the filters panel. */
  label?: string;
}

/**
 * Toggle filters for lessons, court hire, and closures on the unified management calendar.
 */
export function ScheduleSourceTypeFilterBar({
  availableSourceTypes,
  activeSourceFilters,
  onToggle,
  className,
  label,
}: ScheduleSourceTypeFilterBarProps) {
  if (availableSourceTypes.length <= 1) {
    return null;
  }

  const toggles = (
    <div className={className ?? 'flex flex-wrap items-center gap-2'}>
      {availableSourceTypes.map((source) => {
        const active = activeSourceFilters.includes(source);
        return (
          <Button
            key={source}
            type="button"
            size="sm"
            variant={active ? 'default' : 'outline'}
            onClick={() => onToggle(source)}
          >
            {SOURCE_LABELS[source]}
          </Button>
        );
      })}
    </div>
  );

  if (!label) {
    return toggles;
  }

  return (
    <div>
      <p className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">{label}</p>
      {toggles}
    </div>
  );
}
